import { IBetalingStatus } from '@/model/IBetalingStatus';
import { appBetalingenService } from '@/services/appBetalingenService';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Route } from 'vue-router';
import AppBetalingErrorVue from './error/AppBetalingError.vue';
import AppBetalingSuccesVue from './succes/AppBetalingSucces.vue';

@Component({
  components: {
    'app-betaling-succes': AppBetalingSuccesVue,
    'app-betaling-error': AppBetalingErrorVue
  }
})
export default class AppBetalingStatus extends Vue {
  public status: IBetalingStatus | null = null;

  public get isBetalingSuccess(): boolean {
    return this.status?.paymentProviderStatus === 'paid';
  }

  beforeRouteEnter(to: Route, from: Route, next: Function) {
    appBetalingenService.getBetalingStatus(to.params.betalingId).then(status => {
      next((vm: AppBetalingStatus) => {
        vm.status = status;
      });
    });
  }
}
